// Regra de produto (Kaio, 01/10): "o lead não pode ser excluído a qualquer momento, somente nas duas
// primeiras etapas". As duas primeiras etapas de cada funil são "Nova Entrada" e "Novos"
// (`etapas.ordem` 0 e 1 no banco). O banco é quem recusa (migration 0090); esta função só evita
// oferecer o botão onde ele falharia. `tests/unit/exclusao-de-lead-no-banco.test.js` trava que o banco
// e esta lista concordam.
import { STAGES_BY_FUNNEL, STAGES_PROJETOS } from './data.jsx';

const QTD_ETAPAS_QUE_ADMITEM_EXCLUSAO = 2;

function leadAdmiteExclusao(lead) {
  const etapas = STAGES_BY_FUNNEL[lead?.funil] || STAGES_PROJETOS;
  const i = etapas.findIndex((e) => e.id === lead?.stage);
  return i >= 0 && i < QTD_ETAPAS_QUE_ADMITEM_EXCLUSAO;
}

export { QTD_ETAPAS_QUE_ADMITEM_EXCLUSAO, leadAdmiteExclusao };
